module.exports = __webpack_public_path__ + "static/media/IMG_3474-min.723c9798.JPG";